import { render, staticRenderFns } from "./FiltroServico.vue?vue&type=template&id=4d3c7d8d"
import script from "./FiltroServico.vue?vue&type=script&lang=js"
export * from "./FiltroServico.vue?vue&type=script&lang=js"
import style0 from "./FiltroServico.vue?vue&type=style&index=0&id=4d3c7d8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports